import { render, staticRenderFns } from "./codelogin.vue?vue&type=template&id=a80c0b4e"
import script from "./codelogin.vue?vue&type=script&lang=js"
export * from "./codelogin.vue?vue&type=script&lang=js"
import style0 from "./codelogin.vue?vue&type=style&index=0&id=a80c0b4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports